export interface AppStoreState {}
